import { get } from '@appnest/lit-translate';
import { input } from './input';
export const text = ({ cellData, translate, editmode, column, selected, editing }) => {
  return editmode ? input({ cellData, translate, column, editmode, selected })
    : editing && selected.length > 1 ? '(multiple)'
    : cellData === undefined || cellData === null ? ''
    : typeof cellData === 'boolean' ? cellData.toString()
    : translate ? get(cellData)
    : cellData;
};
